@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.config

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017]-[2026] Narbase Technologies
 * All Rights Reserved.
 * Created by khalid-elkhidir
 * On: 2026/04/16.
 */

data class SmsConfigDto(
    val androidAppHash: String?
)